(function () {
  "use strict";
  if (window.Cart) return;

  var API = "/api/method/os_webshop.cart.api.";
  var PING_KEY = "cart_ping"; // cross-tab change signal (no cart data)

  var state = { items: [], count: 0, pending: null, subtotal: 0, delivery: 0, grand_total: 0, datalayer: null };
  var promptEl = null;

  function csrfToken() {
    try {
      return (window.frappe && window.frappe.csrf_token) || window.csrf_token || "";
    } catch (e) { return ""; }
  }

  function call(method, params, httpMethod) {
    httpMethod = (httpMethod || "GET").toUpperCase();
    var headers = { Accept: "application/json" };
    if (httpMethod === "POST") {
      var token = csrfToken();
      if (token) headers["X-Frappe-CSRF-Token"] = token;
      return fetch(API + method, {
        method: "POST",
        credentials: "same-origin",
        headers: headers,
        body: params ? new URLSearchParams(params) : undefined,
      })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (j.message === undefined) throw new Error("Cart: " + method + " failed");
          return j.message;
        });
    }
    var qs = params ? "?" + new URLSearchParams(params).toString() : "";
    return fetch(API + method + qs, { credentials: "same-origin", headers: headers })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.message === undefined) throw new Error("Cart: " + method + " failed");
        return j.message;
      });
  }

  function paintBadges() {
    var n = state.count;
    [].slice.call(document.querySelectorAll(".lx-cartcount")).forEach(function (b) {
      b.textContent = n > 99 ? "99+" : n;
      b.style.display = n > 0 ? "flex" : "none";
    });
  }

  function ping() {
    try { localStorage.setItem(PING_KEY, String(Date.now())); } catch (e) {}
  }

  /* `fromRemote` means "do not tell the other tabs" (they already know).
     `notShopperAction` means "this was not a shopper changing their cart", which
     is a different question and needs its own flag:

       - refresh()   another tab made the change  -> both true
       - markSpent() the order was placed and the server emptied the cart
                     -> must still ping the other tabs, but reporting it as a
                        removal would book remove_from_cart for a basket that was
                        just bought

     Analytics listens for the second flag; ping() still keys off the first. */
  function apply(d, fromRemote, notShopperAction) {
    state.items = (d && d.items) || [];
    state.count = (d && d.count) || 0;
    state.pending = (d && d.pending) || null;
    state.subtotal = (d && d.subtotal) || 0;
    state.delivery = (d && d.delivery) || 0;
    state.grand_total = (d && d.grand_total) || 0;
    // GA4 ecommerce block for the cart as it now stands, built server-side from
    // the same figures the shopper is charged. Carried on the event so a
    // listener can report add/remove without doing price arithmetic itself.
    state.datalayer = (d && d.datalayer) || null;
    paintBadges();
    window.dispatchEvent(new CustomEvent("shop:cart", { detail: { items: state.items, count: state.count, pending: state.pending, datalayer: state.datalayer, notShopperAction: !!notShopperAction } }));
    if (!fromRemote) ping();
    if (state.pending && state.pending.saved && state.pending.saved.length) showPrompt();
    else hidePrompt();
    return state;
  }

  function lines() {
    return state.items.map(function (l) { return { item_code: l.code, qty: l.qty }; });
  }

  function push(newLines) {
    return call("cart_set", { items: JSON.stringify(newLines) }, "POST").then(apply);
  }

  /* ---------------- sign-in cart prompt (never merge silently) ------------- */
  function hidePrompt() {
    if (promptEl) { promptEl.remove(); promptEl = null; }
  }

  function showPrompt() {
    if (promptEl) return;
    var saved = state.pending.saved;
    var savedCount = saved.reduce(function (n, l) { return n + (l.qty || 1); }, 0);
    var esc = function (s) {
      return String(s || "").replace(/[&<>"]/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
      });
    };
    var preview = saved.slice(0, 3).map(function (l) { return esc(l.name); }).join(", ") + (saved.length > 3 ? "…" : "");
    promptEl = document.createElement("div");
    promptEl.setAttribute("role", "dialog");
    promptEl.setAttribute("aria-modal", "true");
    promptEl.style.cssText = "position:fixed;inset:0;background:rgba(19,36,28,.45);z-index:99999;display:flex;align-items:center;justify-content:center;padding:18px";
    promptEl.innerHTML =
      '<div style="background:#fff;border-radius:18px;max-width:440px;width:100%;padding:26px 24px;font-family:\'Plus Jakarta Sans\',system-ui,sans-serif;box-shadow:0 24px 60px rgba(19,36,28,.3)">' +
      '<div style="font-weight:800;font-size:1.08rem;color:#13241C">Welcome back — you have a saved cart</div>' +
      '<div style="color:#4B5A52;font-size:.9rem;margin-top:8px;line-height:1.5">Your account has a saved cart with <b>' + savedCount + " item" + (savedCount !== 1 ? "s" : "") + "</b> (" + preview + "), and this browser has <b>" + state.count + " item" + (state.count !== 1 ? "s" : "") + "</b>. Which would you like to use?</div>" +
      '<div style="display:flex;flex-direction:column;gap:9px;margin-top:18px">' +
      '<button data-cart-choice="current" style="border:none;background:#0E5C3F;color:#fff;font-weight:700;padding:12px 16px;border-radius:999px;cursor:pointer;font-size:.9rem">Keep this cart (' + state.count + ")</button>" +
      '<button data-cart-choice="saved" style="border:1.5px solid #E5E7E1;background:#fff;color:#13241C;font-weight:700;padding:12px 16px;border-radius:999px;cursor:pointer;font-size:.9rem">Use my saved cart (' + savedCount + ")</button>" +
      '<button data-cart-choice="combine" style="border:none;background:none;color:#0E5C3F;font-weight:700;padding:8px;cursor:pointer;font-size:.85rem;text-decoration:underline">Combine both carts</button>' +
      "</div></div>";
    promptEl.addEventListener("click", function (e) {
      var b = e.target.closest && e.target.closest("[data-cart-choice]");
      if (!b) return;
      var choice = b.getAttribute("data-cart-choice");
      [].slice.call(promptEl.querySelectorAll("button")).forEach(function (x) { x.disabled = true; x.style.opacity = ".6"; });
      Cart.resolve(choice);
    });
    document.body.appendChild(promptEl);
  }

  /* ---------------- public API --------------------------------------------- */
  var Cart = (window.Cart = {
    items: function () { return state.items.slice(); },
    count: function () { return state.count; },
    pending: function () { return state.pending; },
    // Server-built GA4 ecommerce block for the current contents. Exposed so a
    // listener that attached after the cart resolved can still read it.
    datalayer: function () { return state.datalayer; },
    totals: function () {
      return {
        subtotal: state.subtotal,
        delivery: state.delivery,
        grand_total: state.grand_total,
      };
    },
    lines: lines,

    add: function (code, qty) {
      if (!code) return Promise.resolve(state);
      qty = qty || 1;
      var next = lines();
      var found = null;
      for (var i = 0; i < next.length; i++) if (next[i].item_code === code) { found = next[i]; break; }
      if (found) found.qty += qty;
      else next.push({ item_code: code, qty: qty });
      // optimistic badge bump; the server response reconciles
      state.count += qty;
      paintBadges();
      return push(next);
    },

    setQty: function (code, qty) {
      var next = lines().filter(function (l) { return !(l.item_code === code && qty <= 0); });
      next.forEach(function (l) { if (l.item_code === code) l.qty = qty; });
      return push(next);
    },

    remove: function (code) { return this.setQty(code, 0); },

    clear: function () { return call("cart_clear", null, "POST").then(apply); },

    refresh: function () { return call("cart_get").then(function (d) { return apply(d, true, true); }); },

    resolve: function (choice) { return call("cart_resolve", { choice: choice }, "POST").then(apply); },

    /* after place_order the server has already cleared the cart — just sync
       the local cache without another round-trip */
    markSpent: function () { return apply({ items: [], count: 0, pending: null }, false, true); },
  });

  /* cross-tab: another tab changed the cart → re-pull */
  window.addEventListener("storage", function (e) {
    if (e.key === PING_KEY) Cart.refresh().catch(function () {});
  });

  /* ---------------- product-card Add buttons (.lx-cardadd) ------------------
     Listing cards (home bestsellers, shop grid, related products, etc.) render
     <button class="lx-cardadd" data-code="…">. Wire them once site-wide so
     every page that ships a card works without per-page scripts.
     PDP uses .lx-addcart with its own qty stepper — leave that alone.
     ------------------------------------------------------------------------ */
  function flashCardAdd(btn) {
    if (!btn) return;
    if (!btn.getAttribute("data-orig")) btn.setAttribute("data-orig", btn.innerHTML);
    var prevBg = btn.style.backgroundColor;
    var prevColor = btn.style.color;
    btn.style.backgroundColor = "#1E8A5A";
    btn.style.color = "#FFFFFF";
    btn.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m5 12 4 4 10-10" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg> Added';
    clearTimeout(btn._lxFlash);
    btn._lxFlash = setTimeout(function () {
      btn.style.backgroundColor = prevBg;
      btn.style.color = prevColor;
      btn.innerHTML = btn.getAttribute("data-orig");
    }, 1400);
  }

  /* Centring with left:50% + translateX(-50%) caps the box at half the viewport,
     which on a phone is ~180px - enough to break "Added to cart" across two
     lines. Below the mobile breakpoint it goes edge to edge instead. That needs
     a media query, so the styling lives in a shared stylesheet rather than in
     cssText. 576px is the same breakpoint the storefront pages use. */
  var TOAST_CSS =
    ".lx-toast{position:fixed;left:50%;right:auto;bottom:26px;transform:translateX(-50%);" +
    "max-width:calc(100vw - 32px);background:#0E5C3F!important;color:#FFFFFF!important;padding:13px 20px;" +
    "border:1px solid rgba(255,255,255,.9)!important;" +
    "border-radius:999px;font-family:'Plus Jakarta Sans',system-ui,sans-serif;font-weight:700;" +
    "font-size:.9rem;box-shadow:0 12px 34px rgba(19,36,28,.32),0 0 0 1px rgba(14,92,63,.3)!important;" +
    "z-index:9999;display:flex;" +
    "align-items:center;gap:14px}" +
    ".lx-toast a{color:#FFD166!important;text-decoration:underline!important;" +
    "text-underline-offset:3px;white-space:nowrap}" +
    "@media(max-width:576px){.lx-toast{left:14px;right:14px;bottom:16px;transform:none;" +
    "max-width:none;border-radius:16px;justify-content:space-between}}";

  function ensureToastCss() {
    if (document.getElementById("lx-toast-css")) return;
    var s = document.createElement("style");
    s.id = "lx-toast-css";
    s.textContent = TOAST_CSS;
    document.head.appendChild(s);
  }

  /* Product-detail pages also create .lx-toast elements from their Builder
     script. Install the shared styling up front so those use the same accessible
     treatment as listing-card notifications. */
  ensureToastCss();

  function toastAdded() {
    var t = document.createElement("div");
    t.setAttribute("role", "status");
    t.className = "lx-toast";
    t.innerHTML = 'Added to cart <a href="/cart">View cart →</a>';
    document.body.appendChild(t);
    setTimeout(function () {
      t.style.transition = "opacity .4s";
      t.style.opacity = "0";
      setTimeout(function () { t.remove(); }, 400);
    }, 2600);
  }

  /* ---------------- variant families ---------------------------------------
     A variant family is listed as one card carrying its *template* item code.
     That code is not purchasable — ERPNext rejects a template on an order line,
     and the shopper still has to choose a size — so the card's Add button has
     to lead to the product page and its picker instead.

     window.lxVariantFamilies is {template_code: "/product/slug"}, published on
     every storefront page by os_ecom_templates (storefront/injectors/families.py).
     Keying off it here, rather than binding a field into each card block, means
     one place covers every listing surface and a family added later needs no
     page edits.
     ------------------------------------------------------------------------ */
  var FAMILY_CTA = "See more";

  function familyRoute(code) {
    var map = window.lxVariantFamilies;
    if (!code || !map || typeof map !== "object") return "";
    return Object.prototype.hasOwnProperty.call(map, code) ? map[code] || "" : "";
  }

  /* Fall back to the card's own product link when the map has no route, so the
     button still leads somewhere sensible rather than doing nothing. */
  function cardRoute(btn, code) {
    var route = familyRoute(code);
    if (route) return route;
    var card = btn.closest && btn.closest(".lx-card");
    var link = card && card.querySelector('a[href^="/product/"]');
    return link ? link.getAttribute("href") : "";
  }

  function decorateFamilyCards(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var btns = scope.querySelectorAll(".lx-cardadd[data-code]");
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (btn.getAttribute("data-lx-family") === "1") continue;
      if (!familyRoute(btn.getAttribute("data-code"))) continue;
      btn.setAttribute("data-lx-family", "1");
      btn.innerHTML = FAMILY_CTA;
      /* It navigates, so let it read and behave as a link. */
      btn.setAttribute("aria-label", FAMILY_CTA);
      btn.removeAttribute("aria-busy");
      btn.disabled = false;
    }
  }
  window.lxDecorateFamilyCards = decorateFamilyCards;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { decorateFamilyCards(); });
  } else {
    decorateFamilyCards();
  }

  document.addEventListener("click", function (e) {
    var btn = e.target && e.target.closest && e.target.closest(".lx-cardadd");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var code = btn.getAttribute("data-code");
    if (!code) return;
    /* Checked live rather than from the decoration pass: a card rendered after
       load still routes correctly even if it was never decorated. */
    if (familyRoute(code)) {
      var to = cardRoute(btn, code);
      if (to) window.location.href = to;
      return;
    }
    if (btn.disabled || btn.getAttribute("aria-busy") === "true") return;
    btn.setAttribute("aria-busy", "true");
    btn.disabled = true;
    Cart.add(code, 1)
      .then(function () {
        flashCardAdd(btn);
        toastAdded();
      })
      .catch(function () {
        /* server rejected — badge already optimistic-bumped; refresh reconciles */
        Cart.refresh().catch(function () {});
      })
      .then(function () {
        btn.removeAttribute("aria-busy");
        btn.disabled = false;
      });
  });

  /* ---------------- boot ---------------------------------------------------- */
  Cart.ready = call("cart_get")
    .then(function (d) { return apply(d, true); })
    .catch(function () { return apply({ items: [], count: 0 }, true); });
})();
